import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-time-picker',
  templateUrl: './custom-time-picker.component.html',
  styleUrls: ['./custom-time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomTimePickerComponent),
      multi: true
    }
  ]
})
export class CustomTimePickerComponent implements OnInit {

  constructor() { }

  @Input() label = '';
  @Input() placeholder;
  @Input() required = false;
  @Input() opcional = false;
  @Input() readonly = false;
  @Input() disabled: boolean = false;

  value: string | null = null; // formato HH:mm
  wasInputFocused = false;
  placeholderValue: string;

  private onChange: any = () => { };
  private onTouched: any = () => { };

  writeValue(value: string | null): void {
    if (value?.includes('T')) {
      this.value = value.split('T')[1]?.slice(0, 5) ?? null;
    } else {
      this.value = value;
    }
  }


  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  updateTime(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
    this.onTouched();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  clearTime() {
    this.value = null;
  }

  ngOnInit() {
    this.placeholderValue = this.placeholder;
  }

}
